<template>
    <div class="content3d--area relative" style="z-index:2; overflow:hidden;">
        <div class="b-container relative" style="padding-top:60px; padding-bottom:60px;">
            <div class="column v-center center mb-xxl">
                <div class="row">
                    <div class="ml-xxl red h1">
                        全国运维服务
                    </div>
                    <div class="relative ml-md" style="width:44px; height:44px;">
                        <img
                            :src="PlusRedIcon"
                            style="width:44px; height:44px; position:absolute; top:-12px; left:0;"
                        />
                    </div>
                </div>
                <div
                    class="secondary t3"
                    style="text-transform: uppercase; letter-spacing:.1em; opacity:.5;"
                >
                   operations service
                </div>
            </div>

            <!-- SWIPER START -->
            <div class="relative swiper-container-wrap" id="case-swiper-wrap">
                <div
                    v-show="paginationBulletsLength !== 1"
                    class="swiper-prev column center v-start"
                >
                    <img :src="IconPrev" style="display:block; width:28px; height:48px;" />
                </div>

                <div v-show="paginationBulletsLength !== 1" class="swiper-next column center v-end">
                    <img :src="IconNext" style="display:block; width:28px; height:48px;" />
                </div>

                <div class="swiper-container" id="case-swiper">
                    <div class="swiper-wrapper">
                        <div
                            v-for="(item, index) in list"
                            class="swiper-slide case-swiper-slide"
                            :key="index"
                        >
                            <!-- <div
                                class="swiper-item column f1 v-center relative secondary-bg hover"
                                :class="{ hover: index == activeIndex }"
                                style="position:absolute; top:0; right:15px; bottom:0; left:15px;"
                                @mouseover="activeIndex = index"
                                @mouseout="activeIndex = -1"
                            > -->
                            <div
                                class="swiper-item column f1 v-center relative secondary-bg hover"
                                style="position:absolute; top:0; right:15px; bottom:0; left:15px;"
                                @mouseover="activeIndex = index"
                                @mouseout="activeIndex = -1"
                            >
                                <div
                                    style="position:absolute; width:100%; height: 100%; z-index:2;"
                                >
                                    <img :src="item.cover" class="card-photo" />
                                </div>
                                <div class="desc px-lg py-lg column">
                                    <div class="h4 mb-md">{{ item.name }}</div>
                                    <!-- <div
                                        v-show="index == activeIndex"
                                        class="t6"
                                        v-html="item.summary"
                                    ></div> -->
                                    <div class="t6" v-html="item.summary"></div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div
                        v-show="paginationBulletsLength !== 1"
                        class="mt-xxl row v-center center"
                        style="height:16px;"
                    >
                        <div class="swiper-pagination333"></div>
                    </div>
                </div>
            </div>
            <!-- SWIPER END -->
        </div>
    </div>
</template>

<script>
import Swiper from 'swiper';
import 'swiper/dist/css/swiper.min.css';

import {
    IconPrev,
    IconNext,
    PlusWhiteIcon,
    PlusRedIcon,
    Arrow,
    Circle,
    Case01,
    Case02,
    Case03,
    Case04,
    Case05,
    Case06,
    Service01,
    Service02,
    Service03,
    Service04,
    Service05,
    Service06,
    Service07,
    Service08,
    Service09,
    Service10
} from '@/constants/pics';

export default {
    name: 'content3d',

    props: [],

    components: {},

    data() {
        return {
            swiper: null,

            IconPrev,
            IconNext,
            PlusWhiteIcon,
            PlusRedIcon,

            Arrow,
            Circle,

            currentItem: 0,
            activeIndex: -1,

            list: [
            {
                    cover: Service03,
                    name: '乐刻健身',
                    summary:
                        '灵鹿为全国数千家乐刻健身提供智能化建设及运维保障服务，加盟商满意度提升17%，灵鹿获得乐刻健身年度“最佳服务奖”。',
                },
                {
                    cover: Service02,
                    name: '美团',
                    summary:
                        '灵鹿为美团提供站点智能化建设及运维保障，帮助总部建立标准化的线上巡检运营体系。',
                },
                {
                    cover: Case01,
                    name: '沃尔沃',
                    summary:
                        '灵鹿为沃尔沃改造升级了全国250余家4S店的拼接屏幕，并为总部建设了统一的内容资产管理平台。',
                },
                {
                    cover: Case02,
                    name: '好特卖',
                    summary:
                        '灵鹿为好特卖提供一站式智能化服务，从监控、客流到音响、宽带，助力品牌快速开店。',
                },
               
                {
                    cover: Service04,
                    name: '江南布衣',
                    summary:
                        '灵鹿为江南布衣提供可视化的退货追溯系统，帮助品牌追回100余万元直接经济损失。',
                },
                {
                    cover: Service01,
                    name: '三米粥铺',
                    summary:
                        '灵鹿为三米粥铺1400余家门店提供全生命周期的开店服务、运营维保，门店开业准备期提效5个工作日。',
                },
                {
                    cover: Service05,
                    name: 'GXG',
                    summary:
                        '灵鹿为GXG提供可视化的退货追溯系统，提高45%的退货效率。',
                }, 
                {
                    cover: Case06,
                    name: '话梅',
                    summary:
                        '灵鹿为仓储式化妆品集合店（话梅）提供可靠稳定的防盗措施，持续降低物物品损耗。',
                },
               
                {
                    cover: Case03,
                    name: '浙大求是',
                    summary: '从浙大校园到医院和住宅，灵鹿为求是物业赋能，持续服务浙大资产。',
                },
                {
                    cover: Service06,
                    name: '坦博尔',
                    summary:
                        '灵鹿助力坦博尔智慧科技，打造可溯源的全链路可视化平台，实现退货数据100%可视化。',
                },
                {
                    cover: Service10,
                    name: '巴拉巴拉',
                    summary:
                        '灵鹿为巴拉巴拉提供了极具性价比的信息互动发布系统，换季按时发布成功率达98%。',
                },
                {
                    cover: Service09,
                    name: '薇娅 X ITIB',
                    summary:
                        '灵鹿为薇娅 X ITIB提供了全新的多媒体展示形式，提高了顾客参与互动性，关注停留市场提升11%。',
                },
               
           
                {
                    cover: Service08,
                    name: '温岭职业技术学院',
                    summary:
                        '灵鹿为国家级重点学校，温岭职业技术学院提供学生画像及在校防轻生系统。',
                },

               {
                    cover: Service07,
                    name: '五龙书院',
                    summary:
                        '灵鹿为侨资民校五龙书院提供特色德育评价体系。',
                },
                
              
             
                {
                    cover: Case04,
                    name: '天真蓝',
                    summary: '灵鹿为天真蓝建设展示系统，通过数字屏幕提升展示形象。',
                },
                {
                    cover: Case05,
                    name: '回收宝',
                    summary: '灵鹿为回收宝改造智能化展柜，精准客流数据，防止员工飞单。',
                },
            ],
        };
    },

    computed: {
        paginationBulletsLength() {
            if (!this.swiper) {
                return 1;
            }

            return this.swiper.pagination.bullets.length;
        },
    },

    created() {},

    mounted() {
        this.$nextTick(function () {
            this.initSwiper();
        });

        let resizeTag = true;
        window.addEventListener('resize', () => {
            if (resizeTag) {
                resizeTag = false;
                setTimeout(() => {
                    resizeTag = true;
                    // this.$nextTick(function() {
                    //     this.initSwiper();
                    // });
                }, 300);
            }
        });
    },

    activated() {},

    deactivated() {},

    methods: {
        onArtistClick() {
            const id = 'test';

            this.$router.push({ path: '/artist' });
        },

        lightbox() {
            this.showLightbox = true;
        },

        close() {
            this.showLightbox = false;
        },

        initSwiper() {
            this.swiper = new Swiper('#case-swiper', {
                slidesPerView: 4,
                slidesPerGroup: 4,
                spaceBetween: 0,

                slidesPerView: 'auto',
                threshold: 10,

                initialSlide: +this.currentItem,
                observer: true,
                observeParents: true,

                navigation: {
                    nextEl: '#case-swiper-wrap .swiper-next',
                    prevEl: '#case-swiper-wrap .swiper-prev',
                },

                pagination: {
                    el: '.swiper-pagination333',
                    clickable: true,
                },

                breakpoints: {
                    // when window width is >= 480px
                    0: {
                        slidesPerView: 1,
                        slidesPerGroup: 1,
                        // spaceBetween: 24,
                    },
                    479: {
                        slidesPerView: 1,
                        slidesPerGroup: 1,
                        // spaceBetween: 24,
                    },
                    480: {
                        slidesPerView: 2,
                        slidesPerGroup: 2,
                        // spaceBetween: 24,
                    },
                    // when window width is >= 720px
                    719: {
                        slidesPerView: 2,
                        slidesPerGroup: 2,
                        // spaceBetween: 24,
                    },
                    720: {
                        slidesPerView: 3,
                        slidesPerGroup: 3,
                        // spaceBetween: 24,
                    },
                    // when window width is >= 1280px
                    1279: {
                        slidesPerView: 3,
                        slidesPerGroup: 3,
                        // spaceBetween: 24,
                    },
                    // when window width is >= 1280px
                    1280: {
                        slidesPerView: 4,
                        slidesPerGroup: 4,
                        // spaceBetween: 24,
                    },
                    // when window width is >= 1280px
                    1392: {
                        slidesPerView: 4,
                        slidesPerGroup: 4,
                        // spaceBetween: 24,
                    },
                    // when window width is >= 1280px
                    5120: {
                        slidesPerView: 4,
                        slidesPerGroup: 4,
                        // spaceBetween: 24,
                    },
                },
            });

            if (this.swiper) {
                this.swiper.on(
                    'slideChange',
                    () => {
                        this.currentItem = this.swiper.activeIndex;
                    },
                );
            }
        },
    },
};
</script>

<style scoped lang="scss">
@import '~@/stylesheets/modules/all';

.content3d-area {
    background: linear-gradient(to right, rgba(255, 51, 85, 1) 0%, rgba(241, 53, 54, 1) 100%);
    overflow: hidden;
}

// swiper-item
.swiper-container {
    width: 100%;
    height: 100%;
}
.swiper-slide {
    // width: 320px;
    // height: 380px;
    text-align: center;
    font-size: 18px;
    display: -webkit-box;
    display: -ms-flexbox;
    display: -webkit-flex;
    display: flex;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    -webkit-justify-content: center;
    justify-content: center;
    -webkit-box-align: center;
    -ms-flex-align: center;
    -webkit-align-items: center;
    align-items: center;

    position: relative;
}

.swiper-slide:after {
    content: '';
    position: relative;
    margin-top: 133.33%;
}

.swiper-next,
.swiper-prev {
    position: absolute;
    top: 0;
    bottom: 0;
    z-index: 10;
    cursor: pointer;
    color: #333;
    width: 64px;
    height: auto;
    border-radius: 12px;
    border-radius: 0;
    will-change: transform;
    transition: all 300ms;
    outline: none;
}

.swiper-next:hover,
.swiper-prev:hover {
    width: 64px;
}

.swiper-next {
    right: -64px;
    left: auto;
    border-radius: 0;
    border-right: 0;
}
.swiper-prev {
    left: -64px;
    right: auto;
    border-radius: 0;
    border-left: 0;
}

//
//
//
a.more {
    color: #666;
    text-decoration: none;
}

// content3d-cover
.content3d-cover {
    background: rgba(127, 127, 127, 0.1);
    overflow: hidden;
}
.content3d-cover:after {
    content: '';
    position: relative;
    margin-top: 100%;
}
.content3d-cover a {
    display: block;
    width: 240px;
    height: 380px;
}

@media (max-width: 991px) {
    .content3d-title {
        padding: 0 15px;
    }

    .h1 {
        font-size: 24px;
    }

    .scroll-wrap {
        width: 100%;
        height: auto;
        overflow-x: auto;
        overflow-y: hidden;
    }
    .scroll-wrap .b-row {
        width: 1085px;
    }

    .b-container {
        padding-left: 0;
        padding-right: 0;
    }

    .b-row {
        margin-left: 0;
        margin-right: 0;
    }

    .company-item-wrap {
        flex: 0 0 320px;
    }

    .company-item {
        width: 240px;
        height: 380px;
    }

    a.more {
        font-size: 16px;
    }

    .title {
        font-size: 16px;
    }

    .summary {
        font-size: 16px;
    }
}

.swiper-item {
    overflow: hidden;
}

.swiper-item .desc {
    will-change: transform;
    transition: all 300ms;
    position: absolute;
    right: 0;
    bottom: 0;
    left: 0;
    height: 80px;
    z-index: 3;
    background: rgba(255, 255, 255, 0.88);
    text-align: left;
}
.swiper-item.hover .desc {
    position: absolute;
    right: 0;
    bottom: 0;
    left: 0;
    height: 196px;
    z-index: 3;
    color: #fff;
    // background: linear-gradient(to bottom, rgba(255, 51, 85, 0.8) 0%, rgba(241, 53, 54, 0.9) 100%);
    background: rgba(0, 0, 0, 0.5);
}

.swiper-button-disabled img {
    opacity: 0.38;
}

.lightbox {
    display: none;
}
.lightbox.display {
    display: block;
}

.swiper-container-wrap {
    margin-left: -15px;
    margin-right: -15px;
}
@media (max-width: 991px) {
    .swiper-container-wrap {
        margin-left: 0;
        margin-right: 0;
    }
}

//
.swiper-pagination .swiper-pagination-bullet-active {
    background: #ffffff !important;
}
</style>
